var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoItems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 200,
    viewBox: "0 0 250 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63 134H154C154.515 134 155.017 133.944 155.5 133.839C155.983 133.944 156.485 134 157 134H209C212.866 134 216 130.866 216 127C216 123.134 212.866 120 209 120H203C199.134 120 196 116.866 196 113C196 109.134 199.134 106 203 106H222C225.866 106 229 102.866 229 99C229 95.134 225.866 92 222 92H200C203.866 92 207 88.866 207 85C207 81.134 203.866 78 200 78H136C139.866 78 143 74.866 143 71C143 67.134 139.866 64 136 64H79C75.134 64 72 67.134 72 71C72 74.866 75.134 78 79 78H39C35.134 78 32 81.134 32 85C32 88.866 35.134 92 39 92H64C67.866 92 71 95.134 71 99C71 102.866 67.866 106 64 106H24C20.134 106 17 109.134 17 113C17 116.866 20.134 120 24 120H63C59.134 120 56 123.134 56 127C56 130.866 59.134 134 63 134ZM226 134C229.866 134 233 130.866 233 127C233 123.134 229.866 120 226 120C222.134 120 219 123.134 219 127C219 130.866 222.134 134 226 134Z",
    fill: "#F2F4F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150.1 58.3027L139 70.7559M124.1 54V70.7559V54ZM98 58.3027L109.1 70.7559L98 58.3027Z",
    stroke: "#D0D5DD",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.406 116.487C109.753 101.716 113.926 94.3312 119.654 92.4301C122.804 91.3843 126.198 91.3843 129.349 92.4301C135.076 94.3312 139.25 101.716 147.597 116.487C155.944 131.257 160.118 138.642 158.866 144.66C158.177 147.97 156.48 150.973 154.018 153.238C149.543 157.354 141.196 157.354 124.501 157.354C107.807 157.354 99.4594 157.354 94.9843 153.238C92.5224 150.973 90.8254 147.97 90.1366 144.66C88.8846 138.642 93.0583 131.257 101.406 116.487Z",
    stroke: "#667085",
    strokeWidth: 5.1875
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.337 141.792V127.958C125.337 126.328 125.337 125.513 124.831 125.006C124.324 124.5 123.509 124.5 121.879 124.5",
    stroke: "#667085",
    strokeWidth: 5.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124.473 114.125H124.504",
    stroke: "#667085",
    strokeWidth: 6.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoItems);
export default __webpack_public_path__ + "static/media/no_items.85a6a2c0f8964a78c7cd26494a3d0454.svg";
export { ForwardRef as ReactComponent };